import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaInstagram, FaLinkedin, FaYoutube, FaSnapchat, FaTiktok, FaWhatsapp,
} from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { Container, Box, Typography } from "@mui/material";

const HERO_IMAGE = "https://i.ibb.co/r2TfpHPS/jpg-2.webp";
const BORDER_THICKNESS = 18;
const SECTION_SPACING = { xs: 10, md: 20 };

const socialLinks = [
  { icon: <FontAwesomeIcon icon={faXTwitter} size="lg" />, link: "https://x.com/digilasersa" },
  { icon: <FaInstagram size={25} />, link: "https://www.instagram.com/digilasersa" },
  { icon: <FaLinkedin size={25} />, link: "https://www.linkedin.com/company/digilasersa" },
  { icon: <FaYoutube size={25} />, link: "https://youtube.com/@digilaserSa" },
  { icon: <FaSnapchat size={25} />, link: "https://www.snapchat.com/add/digilasersa" },
  { icon: <FaTiktok size={25} />, link: "https://www.tiktok.com/@digilasersa" },
  { icon: <FaWhatsapp size={25} />, link: "http://wa.me/966571978888" },
];

const LazyImageBlock = ({ src, alt }) => (
  <Box sx={{ perspective: "1600px", cursor: "pointer" }}>
    <Box sx={{ 
      position: "relative", 
      width: "100%", 
      transformStyle: "preserve-3d", 
      transition: "transform 0.5s ease", 
      "&:hover": { transform: "translateZ(10px)" } 
    }}>
      {/* The Main Image */}
      <Box
        component="img"
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        sx={{
          width: "100%",
          borderRadius: "22px",
          zIndex: 10,
          display: "block",
          boxShadow: { xs: "15px 15px 25px rgba(0,0,0,0.5)", md: "35px 35px 45px rgba(0,0,0,0.65)" },
          backgroundColor: "#111",
          minHeight: { xs: "200px", md: "400px" } 
        }}
      />

      {/* NEW: Bottom Right Button (Matching your image) */}
      <Box sx={{
        position: "absolute",
        bottom: { xs: 15, md: 30 },
        right: { xs: 15, md: 40 },
        zIndex: 15,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        border: "2px solid #06f9f3", // Teal glow border
        borderRadius: "50px", // Pill shape
        px: { xs: 2, md: 4 },
        py: { xs: 0.5, md: 1 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.3s ease",
        "&:hover": {
            backgroundColor: "#06f9f3",
            "& .btn-text": { color: "#000" }
        },
        boxShadow: "0 0 15px rgba(6, 249, 243, 0.4)"
      }}>
        <Typography 
          className="btn-text"
          sx={{ 
            color: "#06f9f3", 
            fontWeight: "bold", 
            fontSize: { xs: "0.8rem", md: "1.1rem" },
            fontFamily: "inherit",
            direction: "rtl" // For correct Arabic rendering
          }}
        >
          انتقل إلى القسم
        </Typography>
      </Box>

      {/* 3D Border Effect */}
      <Box sx={{
          position: "absolute", 
          inset: "-4px", 
          borderRadius: "26px",
          background: "linear-gradient(135deg,#06f9f3,#00b3ff,#06f9f3)",
          filter: "blur(12px)", 
          transform: `translateZ(-${BORDER_THICKNESS}px)`, 
          zIndex: 6,
      }} />
    </Box>
  </Box>
);

const PrintingSection = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Box sx={{ 
        width: "100%", 
        overflow: "hidden", 
        position: "relative", 
        backgroundColor: '#000',
        pt: '60px' 
      }}>
        <img
          src={HERO_IMAGE}
          alt="Printing Hero"
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />

        {/* Floating Social Icons */}
        <Box sx={{
          position: "fixed", top: "50%", left: 0, transform: "translateY(-50%)",
          display: { xs: "none", md: "flex" }, flexDirection: "column", gap: 2, zIndex: 1200, pl: 2,
        }}>
          {socialLinks.map(({ icon, link }, idx) => (
            <a key={idx} href={link} target="_blank" rel="noopener noreferrer">
              <Box sx={{
                width: 40, height: 40, borderRadius: "50%", backgroundColor: "#06f9f3",
                display: "flex", justifyContent: "center", alignItems: "center", color: "#17202a",
                boxShadow: 3, transition: "transform 0.3s ease", "&:hover": { transform: "scale(1.2)" },
              }}>
                {icon}
              </Box>
            </a>
          ))}
        </Box>
      </Box>

      {/* MAIN CONTENT AREA */}
      <Box sx={{
        width: "100%",
        backgroundImage: `url("https://i.ibb.co/Kx0StNYq/rock-texture-wallpaper-min.webp")`,
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        pt: SECTION_SPACING, 
        pb: SECTION_SPACING,
      }}>
        <Container maxWidth="xl" sx={{ 
          px: { xs: 3, md: 6 }, display: "flex", flexDirection: "column", gap: SECTION_SPACING 
        }}>
          
          <Link to="/project01" style={{ textDecoration: 'none' }}>
            <LazyImageBlock src="https://i.ibb.co/XZYQG598/004-1.webp" alt="Arabic Calligraphy" />
          </Link>

          <Link to="/project01" style={{ textDecoration: 'none' }}>
            <LazyImageBlock src="https://i.ibb.co/ksrBBTCj/005-1.jpg" alt="Fine Arts" />
          </Link>

        </Container>
      </Box>
    </>
  );
};

export default PrintingSection;